import { render, staticRenderFns } from "./LPKMember.vue?vue&type=template&id=17b8bb80&scoped=true"
import script from "./LPKMember.vue?vue&type=script&lang=js"
export * from "./LPKMember.vue?vue&type=script&lang=js"
import style0 from "./LPKMember.vue?vue&type=style&index=0&id=17b8bb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8bb80",
  null
  
)

export default component.exports